module.exports = __webpack_public_path__ + "img/diet-5.ebef7aab.jpg";